
import React, { useEffect, useState } from "react";
import MapSVG from "./MapSVG";
import { useSelector } from "react-redux";
import { GrFormClose, GrLocation, GrPhone, GrPhoneHorizontal } from "react-icons/gr";
import { motion } from "framer-motion";
import { fadeIn, slideIn, staggerContainer, } from "./utils/motion";
import Carousel from "react-multi-carousel";


export const MapSection = () => {



  const lang = useSelector((state) => state.cart.lang);
  const region = useSelector((state) => state.cart.branches);

  const [branch_,setBranch] = useState(0)

  const [state,setState] = useState(0)

  const [width, setWidth] = useState(window.innerWidth);
  
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
  //  console.log(window.innerWidth);
    return () => window.removeEventListener("resize", handleResize);
    
  
  }, []);

  const [show,setShow] = useState(0)

  const Branch = ({branch,setBranch,setShow}) => {

  

    return (

      <div style={{cursor:'pointer'}} onClick={()=>{
        setBranch(branch.id)
 if(Images.filter((v)=> Number(v.branch) === Number(branch.id)).length > 0){
                  setImages(Images.filter((v)=> Number(v.branch) === Number(branch.id)))
                }else{
                  setImages([])
                }
if(show !== branch.id && show > 0){
  setShow(0)
}
      }} className="snap-end  snap-always ">
 <div  style={{fontFamily:'',placeContent:'center'}}  className={`w-full flex flex-col item-center  ${width >= 800 ? 'h-[80px]':'h-[80px]' } ${Number(branch_) === Number(branch.id) ? 'bg-[#E0E0E0] ':'bg-neutral-100 '}  mb-1 `}>
 <div style={{placeContent:'center'}}  className={`w-full flex gap-1  `}>
  <p style={{placeContent:'center'}} className={`w-[70%] ${width >= 800 ? 'text-[15px]  ' : 'text-[12px]'} h-[40px] text-[#323131] ${lang === 'en' ? 'text-left' :'text-right'}  px-2 `}>  {lang=== 'en' ? branch.value_en : branch.value }</p>
  <div  className={`w-[30%]  m-auto flex  ${width >= 800 ? ' gap-3':'  gap-1' }`}> 
  <a target="_blank" href={`${branch.location}`} style={{justifyContent:'center'}} className=" " > <GrLocation  color="white" className={`${width >= 800 ? 'h-[25px] w-[25px]':'h-[19px] w-[19px]' }  bg-primary rounded p-[2px] cursor-pointer `}/>  </a>
  <div style={{justifyContent:'center'}} className=" " >  {Number(show) === Number(branch.id) ? <GrFormClose color="white" onClick={()=>{setShow(0)}} className={`${width >= 800 ? 'h-[25px] w-[25px]':'h-[19px] w-[19px]' }  bg-primary rounded p-[2px] cursor-pointer `}  /> : <GrPhone color="white" onClick={()=>{setShow(branch.id)}} className={`${width >= 800 ? 'h-[25px] w-[25px]':'h-[19px] w-[19px]' }  bg-primary rounded p-[2px] cursor-pointer `}  />} </div>
  </div>
 </div>
 
{show === branch.id?
 <div style={{fontFamily:'',overflowX:'auto',overflowY:'hidden'}}  className={`min-w-full h-[40px]  flex  ${width >= 800 ? 'gap-2':'gap-1' } item-center   px-[20px] `}>
 {branch.phones&&branch.phones.map((item, indx) => (
        <>
      
        <a style={{background:'#E6324B',color:'#fff',height:'fit-content'}} className={` ${width >= 800 ? 'text-[12px] py-[2px]   ' : ' py-[1px]   text-[10px]'} px-1  mb-1 rounded flex`}  aria-label={`Mobile${indx}`} key={`phone-${indx}`} href={`tel:${item.phone}`} >
      <p className="m-auto">{item.phone}</p>  <GrPhone className="m-auto" color="white"  size={width >= 800 ? 13 : 10} />  
  </a>
 
        </> 
       

 
  
       

         ))}
 </div>
 
 :''}

  </div>


      </div>
    )

  }





  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 600 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 600, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };
  
  const Img = ({ data ,index, style}) => {
    return (
             
             
      
      <img  width='' height='' draggable={false} src={`https://alhubaishi.future-swift.com/pic/${data.src}`} alt={data.alt} 
     style={{objectFit:'cover'}}  className={` rounded w-full  ${style}`}   /> 
     
       
     
    );
  };
  

  const Images = useSelector((state) => state.cart.images);  
  
  const [images,setImages] = useState(Images)

  var count=0;
  return (
 
      <motion.section
      variants={staggerContainer()}
     initial='hidden'
     whileInView='show'
     viewport={{ once:true, amount: 0.25 }} className=" mt-[8px] px-[3%] bg-white w-full">
    <span className='hash-span' id={'Branches'}>
   
    </span>

    <motion.div variants={slideIn('right', '', 0.1, 1)} >
      <div className={`flex ${width >= 800 ? 'flex-row' : 'flex-col' }  gap-5  pt-10`}  >
      <h2 onClick={()=>setState(0)} style={{fontFamily:'CairoExtraBold',placeContent:'center'}}  className={`self-start min-h-[80px] ${width >= 800 ? 'min-w-[40%]' : 'min-w-full' } bg-neutral-100 text-primary text-center text-[15px]  lg:text-[40px]  md:text-[30px]  sm:text-[20px]  xs:text-[15px] `}>
      { lang === 'en' ? 'Branches' :'فروعنا'}   
          </h2>
          <div style={{overflowX:'auto'}} className={`flex ${width >= 800 ? 'min-w-[60%]' : 'min-w-full' } gap-2 `}>
          {region.map((region, i) => (
            <button
              key={`Branch${i}`}
              onClick={()=>{
            
                setState(region.id)
                if(Images.filter((v)=> Number(v.region) === Number(region.id)).length > 0){
                  setImages(Images.filter((v)=> Number(v.region) === Number(region.id)))
                }else{
                  setImages([])
                }
                
                setBranch(0)
                setShow(0)

                }}
              style={{placeContent:'center'}}
              className={`  grow shrink min-h-[80px] min-w-[100px]  bg-neutral-100 
              ${Number(region.id)===  Number(state) ? ' min-w-[180px]  bg-primary text-white' : ''}
               `}
            >
             {lang=== 'en' ? region.value_en : region.value }

             <p style={{display:'none'}}>{count += Number(region.branch_count)}</p>
            </button>
          ))}
          </div>
      </div>
   
<div className={`flex ${width >= 800 ? 'flex-row' : 'flex-col ' }  gap-5  pt-10`}  >
{
state > 0 ?  
<div className={`self-start  ${width >= 800 ? 'min-w-[40%] flex-col  ' : 'min-w-full' }   `}>

<div style={{overflowY:width >= 800 ? 'auto':'hidden'}} className={` ${width >= 800 ? ' h-[260px]   p-1 ':' flex gap-1 h-[200px]' } bg-white snap-y snap-mandatory `}>


{width >= 800 ?


 

region.filter(item => Number(item.id) === Number(state))[0].branches.length > 0 ?

region.filter(item => Number(item.id) === Number(state))[0].branches.map((branch, i) => (
 <Branch setShow={setShow} setBranch={setBranch} branch={branch} />
))
 :''
  
  

:
<>

<div  style={{overflowY:'auto',width:`${width*0.40}px`}} className={`bg-white-100  max-w-[45%] flex-col h-[200px] snap-y snap-mandatory `}>


 
{
  region.filter(item => Number(item.id) === Number(state))[0].branches.length > 0 ?

region.filter(item => Number(item.id) === Number(state))[0].branches.map((branch, i) => (
 <Branch setShow={setShow} setBranch={setBranch} branch={branch} />
))
  :''

 

}

</div>

<div style={{width:`${width*0.54}px`}}  className={`bg-neutral-100  h-[200px] `}>
{images.length > 0 ?
<Carousel
   // arrows={false}
    swipeable={true}
    showDots={true}
  //  customButtonGroup={<ButtonGroup />}
   // renderDotsOutside={true}
      responsive={responsive}
      ssr={true} // means to render carousel on server-side.
      infinite={true}
    autoPlay={true}
    
      autoPlaySpeed={3000}
    
  //arrows={false}
   
    >
        
{images.map((item, index) => (
  
 
         
         
         
         <Img
           key={`img_${index}`}
         data={item}
         index={index}
         style={'h-[200px]'}
         />

       

       ))}
           

          
   
    
    
    </Carousel>
    
  :
  <img className={`m-auto bg-neutral-100 w-full max-h-[200px]`}  width='' height='' src="./logo.svg" />  
    }
</div>

</>

}




                   
</div>
          
<div  className={` ${width >= 800 ? ' ':'hidden' }  `}>
{images.length > 0 ?
<Carousel
   // arrows={false}
    swipeable={true}
    showDots={true}
  //  customButtonGroup={<ButtonGroup />}
   // renderDotsOutside={true}
      responsive={responsive}
      ssr={true} // means to render carousel on server-side.
      infinite={true}
    autoPlay={true}
    
      autoPlaySpeed={3000}
    
  //arrows={false}
   
    >
        
{images.map((item, index) => (
  
 
         
         
         
         <Img
           key={`img_${index}`}
         data={item}
         index={index}
         style={width >= 800 ? 'max-h-[200px] xl:max-h-[300px] ':'' }
         />

       

       ))}
           

          
   
    
    
    </Carousel>


    :
    <img className={`m-auto bg-neutral-100 w-full ${width >= 800 ? 'max-h-[200px] xl:max-h-[300px] ':'' }`}  width='' height='' src="./logo.svg" />
}
          </div>
</div>
:

<div className={`flex flex-col self-start bg-neutral-100  ${width >= 800 ? 'min-w-[40%] flex-col h-[460px] xl:h-[650px] ' : 'min-w-full h-[200px] ' }   `}>
<img className={`m-auto  ${width >= 800 ? ' max-h-[460px] xl:max-h-[560px] ' : ' max-h-[190px] ' }`} width='50%' height='' src="./logo.svg" />
</div>

}
     
          <div  style={{overflowX:'auto'}} className="relative  bg-neutral-100 min-w-[60%]">
          <p style={{placeContent:'center'}}  className={`absolute top-2 w-full  text-[#737373] text-center text-[10px]  lg:text-[20px]  md:text-[15px]  sm:text-[12px]  xs:text-[10px]  `}>
         {
          state > 0 ? 

          lang ==='en' ?
          `${region.filter(item => Number(item.id) === Number(state))[0].branch_count}  Branches in the governorate ${region.filter(item => Number(item.id) === Number(state))[0].value_en} `
          :
           `${region.filter(item => Number(item.id) === Number(state))[0].branch_count} فروع في  محافظة ${region.filter(item => Number(item.id) === Number(state))[0].value} `
          :
          lang ==='en' ?
           `${count} Branches in ${region.length} governorates in the Republic of Yemen `
           :
          `${count} فروع في ${region.length} محافظات في الجمهورية اليمنية`
          }
          </p>
         <MapSVG width={'100%'} color={"#E6324B"} used={region}  state={Number(state)}  setState={setState}/>
         

          </div>
      </div>

      </motion.div> 

    </motion.section>
    
  );
};
